import { styled } from '@material-ui/core';
import { SInput } from '@setvi/shared/components';
import { BaseLabelValueFieldCard } from '../../../../../styled';

export const EnhancedLabelValueFieldCard = styled(BaseLabelValueFieldCard)({
  backgroundColor: 'transparent',
  border: 'none'
});

export const EnhancedLabelValueFieldInput = styled(SInput)({
  '&.MuiFormControl-root': {
    marginBottom: 0,
    width: '100%'
  },
  '& .MuiInputBase-root': {
    height: 'auto'
  }
});
